export enum AnimationType {
  None,
  PushRight,
  PushBottom,
  Pop,
}
